// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","root":"root-1Pxie","list":"list-Usa_U","skeleton__list":"skeleton__list-2oHzw","empty":"empty-29H5v"};